import { Pages } from "./Pages";

export class Category extends Pages {
    init() {
        console.log(this.param(1));
        this.render("", null);
    }
}